var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPhonepe(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 51,
    height: 52,
    viewBox: "0 0 51 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3819_2454)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M50.3128 31.9743C53.5487 18.0018 45.0628 4.00021 31.359 0.70086C17.6552 -2.59849 3.9229 6.05379 0.686997 20.0263C-2.5489 33.9988 5.93699 48.0003 19.6408 51.2997C33.3445 54.599 47.0769 45.9468 50.3128 31.9743Z",
    fill: "#5F259F"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.0709 19.2159C37.0709 18.1994 36.2167 17.3275 35.2198 17.3275H31.8009L23.9678 8.17836C23.2552 7.30726 22.1159 7.01659 20.9765 7.30726L18.2701 8.17836C17.8426 8.32359 17.7001 8.90494 17.9851 9.1947L26.5315 17.4729H13.5703C13.1426 17.4729 12.8577 17.7634 12.8577 18.1994V19.651C12.8577 20.6682 13.7128 21.5392 14.7096 21.5392H16.7033V28.5104C16.7033 33.7384 19.4097 36.7876 23.9679 36.7876C25.3915 36.7876 26.5317 36.6423 27.9553 36.0618V40.7086C27.9553 42.0157 28.9529 43.033 30.2348 43.033H32.2285C32.6561 43.033 33.0829 42.597 33.0829 42.161V21.3939H36.3593C36.7868 21.3939 37.071 21.1033 37.071 20.6682V19.2159H37.0709ZM27.9553 31.7047C27.101 32.1406 25.9616 32.2859 25.1073 32.2859C22.8277 32.2859 21.6883 31.1243 21.6883 28.5103V21.5391H27.9553V31.7047Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3819_2454"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 51,
    height: 52,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhonepe);
export default __webpack_public_path__ + "static/media/phonepe.b9cf4c77d43e3b511e0f7f9855f8454b.svg";
export { ForwardRef as ReactComponent };